import { ImoduleFilter, WAREHOUSE_FILTER_QUERY_NAME } from 'types/global';

export const removeWarehousePlaceTrelloFilters = (filters: ImoduleFilter[]): ImoduleFilter[] =>
  filters.filter(filter => filter?.name !== WAREHOUSE_FILTER_QUERY_NAME);

export const isWarehousePlaceTrelloFilterActive = (filters: ImoduleFilter[]): boolean =>
  Boolean(
    filters?.some(
      filter =>
        filter?.name === WAREHOUSE_FILTER_QUERY_NAME &&
        Array.isArray(filter?.values) &&
        filter.values.map(String).includes('true')
    )
  );

export const appendWarehousePlaceTrelloFilters = (filters: ImoduleFilter[]): ImoduleFilter[] => {
  const base = removeWarehousePlaceTrelloFilters(filters);
  const warehouseEntry: ImoduleFilter = {
    name: WAREHOUSE_FILTER_QUERY_NAME,
    includes: 'eq',
    values: ['true']
  };
  return [...base, warehouseEntry];
};
